/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIndicatorTestRecalculatedSimpleDto
 */
export interface GetIndicatorTestRecalculatedSimpleDto {
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedSimpleDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedSimpleDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedSimpleDto
     */
    mode: string;
    /**
     * 
     * @type {number}
     * @memberof GetIndicatorTestRecalculatedSimpleDto
     */
    result: number;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedSimpleDto
     */
    normName: string;
    /**
     * 
     * @type {number}
     * @memberof GetIndicatorTestRecalculatedSimpleDto
     */
    recalculatedResult: number;
    /**
     * 
     * @type {string}
     * @memberof GetIndicatorTestRecalculatedSimpleDto
     */
    interpretedResult: string;
}

/**
 * Check if a given object implements the GetIndicatorTestRecalculatedSimpleDto interface.
 */
export function instanceOfGetIndicatorTestRecalculatedSimpleDto(value: object): value is GetIndicatorTestRecalculatedSimpleDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('mode' in value) || value['mode'] === undefined) return false;
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('normName' in value) || value['normName'] === undefined) return false;
    if (!('recalculatedResult' in value) || value['recalculatedResult'] === undefined) return false;
    if (!('interpretedResult' in value) || value['interpretedResult'] === undefined) return false;
    return true;
}

export function GetIndicatorTestRecalculatedSimpleDtoFromJSON(json: any): GetIndicatorTestRecalculatedSimpleDto {
    return GetIndicatorTestRecalculatedSimpleDtoFromJSONTyped(json, false);
}

export function GetIndicatorTestRecalculatedSimpleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIndicatorTestRecalculatedSimpleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'mode': json['mode'],
        'result': json['result'],
        'normName': json['normName'],
        'recalculatedResult': json['recalculatedResult'],
        'interpretedResult': json['interpretedResult'],
    };
}

export function GetIndicatorTestRecalculatedSimpleDtoToJSON(value?: GetIndicatorTestRecalculatedSimpleDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'mode': value['mode'],
        'result': value['result'],
        'normName': value['normName'],
        'recalculatedResult': value['recalculatedResult'],
        'interpretedResult': value['interpretedResult'],
    };
}

